import { Button, Modal } from 'react-bootstrap';

import useRemoteBoundStore from 'src/store/useRemoteBoundStore';

import CustomModal from 'src/components/custom_components/CustomModal/CustomModal';

import useCancelCaptureImages from 'src/hooks/camera/useCancelCaptureImages';
import { useContinueCaptureProcess } from 'src/hooks/camera/useContinueCaptureProcess';
import { useGetCurrentCaptureProcess } from 'src/hooks/camera/useGetCurrentCaptureProcess';
import useUiTranslation from 'src/hooks/useUiTranslation';

const SmallPupilModal = () => {
  const { tPages } = useUiTranslation();

  const { isCanceling } = useRemoteBoundStore();

  const { handleCancelCapture } = useCancelCaptureImages();

  const { continueCaptureProcess } = useContinueCaptureProcess();

  const handleContinueCaptureProcess = () => {
    continueCaptureProcess();
  };

  const { currentCaptureProcess } = useGetCurrentCaptureProcess();

  // TODO: contact with MediWork to test the small pupil feature
  const handleExit = async () => {
    handleCancelCapture();
  };

  return (
    <CustomModal show={currentCaptureProcess?.isPupilSmall}>
      <Modal.Header>
        <Modal.Title>{tPages('newExam.smallPupil.title')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{tPages('newExam.smallPupil.desc')}</Modal.Body>
      <Modal.Footer>
        <Button
          variant="primary-100"
          className="text-primary"
          onClick={handleContinueCaptureProcess}
          disabled={isCanceling}
        >
          {tPages('newExam.smallPupil.continue')}
        </Button>
        <Button variant="primary" onClick={handleExit} disabled={isCanceling}>
          {isCanceling
            ? tPages('newExam.cancelingImaging')
            : tPages('newExam.cancelImaging')}
        </Button>
      </Modal.Footer>
    </CustomModal>
  );
};

export default SmallPupilModal;
